import { createFileRoute } from "@tanstack/react-router";
import VariantB from "@/components/funnel/variants/VariantB";
import { BRAND_META_DESCRIPTION, BRAND_NAME } from "@/components/inflow/brand";

export const Route = createFileRoute("/lp-b")({
  head: () => ({
    meta: [
      { title: `${BRAND_NAME} — Variant B` },
      { name: "description", content: BRAND_META_DESCRIPTION },
      { name: "robots", content: "noindex,nofollow" },
      { property: "og:title", content: `${BRAND_NAME} — Variant B` },
      { property: "og:description", content: BRAND_META_DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: VariantB,
});
